import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ChangePassword } from "../../interfaces/index";
import { CommonService } from "../../api/index";
import { SnackService } from "../../services/index";
import { NgForm } from "@angular/forms";

@Component({
  selector: 'school-changepwd-ui',
  templateUrl: './change-password-ui.component.html',
  styleUrls: ['./change-password-ui.component.scss']
})
export class ChangepwdUiComponent implements OnInit {

  passwordFormValue = {} as ChangePassword;

  currentpwdhide = true;
  newpwdhide = true;
  confirmpwd = true;

  @Input() formtype: string;
  @Output() accordionEvent = new EventEmitter();
  @ViewChild("passwordform", { static: false }) passwordsform: NgForm;

  constructor(private route: Router,
    private _userService: CommonService,
    private _snackService: SnackService,
  ) { }

  ngOnInit(): void {
  }

  cancelClick() {
    if (this.formtype == 'accordion') {

      this.accordionEvent.emit(false);
    }
    else {
      this.route.navigate([`/${this.formtype}`]);
    }
  }


  onSubmit(): void {

    const saveData = { ...this.passwordFormValue };

    this._userService.savePasswords(saveData).subscribe(
      result => {
        this.passwordsform.resetForm();
        if (result.body.code == 401) {
          this._snackService.openSnackBar("danger", result.body.message);
        }
        else {
          this._snackService.openSnackBar("success", result.body.message);
        }

      }, error => {
        this._snackService.openSnackBar("danger", error.error.message);
      });
  }



}
